import React from 'react';

// ponytail: single self-framed film; the old 5-min walkthrough was cut because
// it pitched the pre-Factory-Agent story — re-add a long-form video when one
// matching the current positioning is recorded.
const DemoSection = () => (
  <section id="demo" className="py-24 bg-white dark:bg-black">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <div className="font-mono text-xs tracking-[0.25em] uppercase text-emerald-600 dark:text-emerald-400 mb-4">02 — The film</div>
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-gray-900 dark:text-white mb-5">
          See it working
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
          A robot cell programmed, simulated, and verified by the Factory Agent — real product, not a mockup.
        </p>
      </div>

      <div className="mx-auto max-w-5xl rounded-xl overflow-hidden border border-black/10 dark:border-white/10 bg-gray-950 shadow-2xl shadow-emerald-500/5">
        <video
          src="/videos/demo-loop.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="w-full block"
        />
      </div>
    </div>
  </section>
);

export default DemoSection;
